import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Button } from 'react-bootstrap';

const RED = '#cc0000';
const EXPO = [0.22, 1, 0.36, 1];

export const QualityPolicyImage = ({ maxWidth = '720px' }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-40px' });

  const corners = [
    { top: '-8px', left: '-8px', borderTop: `2px solid ${RED}`, borderLeft: `2px solid ${RED}` },
    { top: '-8px', right: '-8px', borderTop: `2px solid ${RED}`, borderRight: `2px solid ${RED}` },
    { bottom: '-8px', left: '-8px', borderBottom: `2px solid ${RED}`, borderLeft: `2px solid ${RED}` },
    { bottom: '-8px', right: '-8px', borderBottom: `2px solid ${RED}`, borderRight: `2px solid ${RED}` },
  ];

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 28 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: EXPO }}
      style={{ position: 'relative', width: '100%', maxWidth, margin: '0 auto' }}
    >
      {corners.map((s, i) => (
        <div key={i} style={{ position: 'absolute', width: '18px', height: '18px', zIndex: 3, ...s }} />
      ))}
      <div style={{
        position: 'relative', zIndex: 1,
        background: '#ffffff',
        borderRadius: '4px',
        padding: '12px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)',
        border: '1px solid #ececec',
      }}>
        <img
          src="/Images/QualityPolicy.png"
          alt="Decal Tech Quality Policy"
          style={{
            display: 'block',
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
            borderRadius: '2px',
          }}
        />
      </div>
    </motion.div>
  );
};

const QualityPolicyBlock = ({ showCta = false, compact = false }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <section
      ref={ref}
      style={{
        padding: compact ? '40px 60px 44px' : '52px 60px 56px',
        textAlign: 'center',
        background: 'linear-gradient(180deg, #f4f4f4 0%, #faf8f8 50%, #ffffff 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div style={{
        position: 'absolute', top: '-80px', left: '50%', transform: 'translateX(-50%)',
        width: '600px', height: '200px',
        background: 'radial-gradient(ellipse, rgba(204,0,0,0.05) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.7, ease: EXPO }}
        style={{ position: 'relative', zIndex: 1, maxWidth: '720px', margin: '0 auto' }}
      >
        <h3 style={{
          fontSize: '2rem',
          fontWeight: 700,
          color: '#111',
          letterSpacing: '-0.5px',
          margin: '0 0 10px',
        }}>
          Our Quality Policy
        </h3>
        <p style={{
          fontSize: '15px',
          color: '#666',
          margin: '0 auto 32px',
          maxWidth: '480px',
          lineHeight: 1.65,
        }}>
          Committed to the highest standards in every product we manufacture and deliver.
        </p>

        <QualityPolicyImage maxWidth={compact ? '500px' : '720px'} />

        {showCta && (
          <Button
            href="/qualitypolicy"
            variant="outline-dark"
            style={{
              borderRadius: '2px',
              padding: '11px 28px',
              fontWeight: 600,
              letterSpacing: '1.2px',
              fontSize: '12px',
              textTransform: 'uppercase',
              marginTop: '28px',
              transition: 'transform 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            Learn More
          </Button>
        )}
      </motion.div>
    </section>
  );
};

export default QualityPolicyBlock;
